// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "cf9a09f6ad709b72c31ee688eb4285c2" + ".js";
};